import { useEffect, useState } from "react";
import { contextFactory } from "./contextFactory";

export type ViewportContext = {
  windowWidth: number;
  windowHeight: number;
  horCenter: (width: number) => number;
  vertCenter: (height: number) => number;
};

export const { Provider: ViewportProvider, useCustomContext: useViewport } =
  contextFactory<ViewportContext>(function viewportContext() {
    const [windowWidth, setWidth] = useState(window.innerWidth);
    const [windowHeight, setHeight] = useState(window.innerHeight);

    useEffect(() => {
      const handleWindowResize = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
      };

      window.addEventListener("resize", handleWindowResize);
      return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    const horCenter = (width: number) => (windowWidth - width) / 2;
    const vertCenter = (height: number) => (windowHeight - height) / 2;

    return { windowWidth, windowHeight, horCenter, vertCenter };
  });
